<template>
  <div class="home_page">
    <!-- 导航栏 -->
    <nav class="top_nav">
      <div class="nav_left">
        <a
          v-for="(item, index) in navItems"
          :key="index"
          href="javascript:;"
          class="nav_item"
          :class="{ active: activeNav === index }"
          @click="activeNav = index"
        >
          {{ item }}
        </a>
      </div>
      <div class="nav_right">
        <button class="nav_btn_login" @click="goToLogin">登陆</button>
      </div>
    </nav>

    <!-- 主轮播图区域 -->
    <div class="hero_section">
      <swiper ref="heroSwiper" :options="swiperOption" class="hero_swiper">
        <swiper-slide v-for="(item, index) in bannerList" :key="index" class="swiper-slide">
          <div class="banner_item">
            <!-- 模糊背景层 -->
            <div class="banner_bg_blur" :style="{ backgroundImage: `url(${item.image})` }"></div>
            <!-- 直播展示内容以及视频 -->
            <div class="banner_img">
                <!-- 视频流 -->
                <video src=""></video>
                <!-- webrtc 流 -->
                <div></div>
            </div>
            <!-- 蒙层 -->
            <div class="banner_overlay"></div>
            <!-- 左侧信息 -->
            <div class="banner_info">
              <span class="live_tag">直播中</span>
              <h2 class="banner_title">{{ item.title }}</h2>
              <p class="banner_subtitle">{{ item.subtitle }}</p>
              <div class="anchor_info">
                <img :src="item.avatar" class="anchor_avatar" />
                <span class="anchor_name">{{ item.anchorName }}</span>
              </div>
              <div class="stats">
                <span class="stat_item">{{ item.viewers }} 人正在观看</span>
                <span class="stat_item">{{ item.likes }} 人喜欢</span>
              </div>
            </div>
            <!-- 右侧进入按钮 -->
            <button class="enter_btn" @click="enterLiveRoom">点击进入直播</button>
          </div>
        </swiper-slide>
      </swiper>
      <!-- 上下切换按钮 -->
      <div class="swiper_nav_btns">
        <button class="nav_btn nav_btn_prev" @click="slidePrev">
          <i class="el-icon-arrow-up"></i>
        </button>
        <button class="nav_btn nav_btn_next" @click="slideNext">
          <i class="el-icon-arrow-down"></i>
        </button>
      </div>
    </div>

    <!-- 甜筒精选 -->
    <section class="section">
      <div class="section_header">
        <h3 class="section_title">甜筒精选</h3>
        <span class="section_subtitle">此处封面图上有蒙层</span>
      </div>
      <div class="featured_grid">
        <div v-for="item in featuredList" :key="item.id" class="featured_card" @click="enterLiveRoom">
          <div class="card_image_wrap">
            <div class="card_image" :style="{ background: item.bgColor }"></div>
            <div class="card_overlay"></div>
            <span class="card_tag" :class="item.tagType">{{ item.tag }}</span>
            <span class="viewer_count">
              <i class="el-icon-user"></i>{{ item.viewers }}
            </span>
          </div>
          <div class="card_info">
            <img :src="item.avatar" class="card_avatar" />
            <span class="card_name">{{ item.name }}</span>
          </div>
        </div>
      </div>
    </section>

    <!-- 推荐类别 -->
    <section class="section">
      <h3 class="section_title">推荐类别</h3>
      <div class="category_grid">
        <div v-for="item in categoryList" :key="item.id" class="category_card" @click="enterLiveRoom">
          <div class="category_image" :style="{ background: item.bgColor }"></div>
          <div class="category_overlay"></div>
          <span class="category_tag">{{ item.tag }}</span>
          <div class="category_anchor">
            <img :src="item.avatar" class="category_avatar" />
            <span class="category_name">{{ item.name }}</span>
          </div>
        </div>
      </div>
    </section>

    <!-- 甜筒活动 -->
    <section class="section">
      <h3 class="section_title">甜筒活动</h3>
      <div class="activity_grid">
        <div v-for="item in activityList" :key="item.id" class="activity_card" @click="enterLiveRoom">
          <div class="activity_image" :style="{ background: item.bgColor }"></div>
        </div>
      </div>
    </section>

    <!-- 音乐 -->
    <section class="section">
      <h3 class="section_title">音乐</h3>
      <div class="live_grid">
        <div v-for="item in musicList" :key="item.id" class="live_card" @click="enterLiveRoom">
          <div class="live_image_wrap">
            <div class="live_image" :style="{ background: item.bgColor }"></div>
            <span class="live_status">直播中</span>
          </div>
          <div class="live_info">
            <img :src="item.avatar" class="live_avatar" />
            <span class="live_name">{{ item.name }}</span>
          </div>
        </div>
      </div>
    </section>

    <!-- 乐器 -->
    <section class="section">
      <h3 class="section_title">乐器</h3>
      <div class="live_grid">
        <div v-for="item in instrumentList" :key="item.id" class="live_card" @click="enterLiveRoom">
          <div class="live_image_wrap">
            <div class="live_image" :style="{ background: item.bgColor }"></div>
            <span class="live_status">直播中</span>
          </div>
          <div class="live_info">
            <img :src="item.avatar" class="live_avatar" />
            <span class="live_name">{{ item.name }}</span>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { Swiper, SwiperSlide } from 'vue-awesome-swiper'
import 'swiper/css/swiper.css'
import axios from 'axios';
export default {
  name: 'HomePage',
  components: {
    Swiper,
    SwiperSlide
  },
 
  data() {
    return {
      // 导航栏数据
      navItems: ['音乐', '乐器', '舞蹈', '脱口秀', '二次元', '颜值', '才艺', '生活方式', '团舞', '翻唱'],
      activeNav: 0,
      // 轮播图配置 - 竖向
      swiperOption: {
        direction: 'vertical',
        slidesPerView: 1,
        spaceBetween: 0,
        mousewheel: true, // 启用鼠标滚轮控制
        autoplay: {
          delay: 3000,
          disableOnInteraction: false
        },
        loop: true
      },
      // 预加载的下一条数据
      nextData: null,
      // 轮播图数据 - 初始假数据
      bannerList: [
        {
          image: require('../../assets/Heng.png'),
          bgImage: require('../../assets/Heng.png'),
          title: '今晚想听什么？',
          subtitle: '来点歌吧！',
          anchorName: '甜甜音悦台',
          avatar: 'https://via.placeholder.com/40',
          viewers: '25,000',
          likes: '18000'
        },
        {
          image: require('../../assets/JUXING.png'),
          bgImage: require('../../assets/JUXING.png'),
          title: '深夜电台',
          subtitle: '陪你入睡',
          anchorName: '电台小王子',
          avatar: 'https://via.placeholder.com/40',
          viewers: '18,000',
          likes: '12000'
        }
      ],
      // 甜筒精选
      featuredList: [
        { id: 1, bgColor: 'linear-gradient(135deg, #8A3FFC 0%, #A855F7 100%)', tag: '直播', tagType: 'live', viewers: '12345', avatar: 'https://via.placeholder.com/30', name: '甜甜音悦台' },
        { id: 2, bgColor: 'linear-gradient(135deg, #C084FC 0%, #E9D5FF 100%)', tag: '回放', tagType: 'replay', viewers: '233', avatar: 'https://via.placeholder.com/30', name: '甜甜音悦台' },
        { id: 3, bgColor: 'linear-gradient(135deg, #7C3AED 0%, #8B5CF6 100%)', tag: '直播', tagType: 'live', viewers: '233', avatar: 'https://via.placeholder.com/30', name: '甜甜音悦台' }
      ],
      // 推荐类别
      categoryList: [
        { id: 1, bgColor: 'linear-gradient(135deg, #FF6B9D 0%, #FF8FB0 100%)', tag: '#颜值', name: '兔小兔 直播中', avatar: 'https://via.placeholder.com/24' },
        { id: 2, bgColor: 'linear-gradient(135deg, #C084FC 0%, #E9D5FF 100%)', tag: '#舞蹈', name: '兔小兔 直播中', avatar: 'https://via.placeholder.com/24' },
        { id: 3, bgColor: 'linear-gradient(135deg, #4ECDC4 0%, #7EDDD7 100%)', tag: '#乐器', name: '兔小兔 直播中', avatar: 'https://via.placeholder.com/24' },
        { id: 4, bgColor: 'linear-gradient(135deg, #95E1D3 0%, #B8F0E6 100%)', tag: '#宅舞 二次元', name: '兔小兔 直播中', avatar: 'https://via.placeholder.com/24' },
        { id: 5, bgColor: 'linear-gradient(135deg, #F38181 0%, #F5A0A0 100%)', tag: '#街舞', name: '魔丸 直播中', avatar: 'https://via.placeholder.com/24' },
        { id: 6, bgColor: 'linear-gradient(135deg, #AA96DA 0%, #C4B8E8 100%)', tag: '#生活方式', name: '兔小兔 直播中', avatar: 'https://via.placeholder.com/24' },
        { id: 7, bgColor: 'linear-gradient(135deg, #FCBAD3 0%, #FDD4E5 100%)', tag: '#女团舞', name: '兔小兔 直播中', avatar: 'https://via.placeholder.com/24' },
        { id: 8, bgColor: 'linear-gradient(135deg, #F7DC6F 0%, #F9E79F 100%)', tag: '#翻唱', name: '兔小兔 直播中', avatar: 'https://via.placeholder.com/24' },
        { id: 9, bgColor: 'linear-gradient(135deg, #A8D8EA 0%, #C5E7F5 100%)', tag: '#cosplay', name: '兔小兔 直播中', avatar: 'https://via.placeholder.com/24' },
        { id: 10, bgColor: 'linear-gradient(135deg, #AA96DA 0%, #C4B8E8 100%)', tag: '#脱口秀', name: '魔丸 直播中', avatar: 'https://via.placeholder.com/24' }
      ],
      // 甜筒活动
      activityList: [
        { id: 1, bgColor: 'linear-gradient(135deg, #8A3FFC 0%, #A855F7 100%)' },
        { id: 2, bgColor: 'linear-gradient(135deg, #4A90E2 0%, #6BA5E7 100%)' },
        { id: 3, bgColor: 'linear-gradient(135deg, #50C878 0%, #7FD99E 100%)' }
      ],
      // 音乐
      musicList: [
        { id: 1, bgColor: 'linear-gradient(135deg, #8A3FFC 0%, #A855F7 100%)', name: '兔小兔 直播中', avatar: 'https://via.placeholder.com/24' },
        { id: 2, bgColor: 'linear-gradient(135deg, #C084FC 0%, #E9D5FF 100%)', name: '兔小兔 直播中', avatar: 'https://via.placeholder.com/24' },
        { id: 3, bgColor: 'linear-gradient(135deg, #7C3AED 0%, #8B5CF6 100%)', name: '兔小兔 直播中', avatar: 'https://via.placeholder.com/24' },
        { id: 4, bgColor: 'linear-gradient(135deg, #A855F7 0%, #C084FC 100%)', name: '兔小兔 直播中', avatar: 'https://via.placeholder.com/24' },
        { id: 5, bgColor: 'linear-gradient(135deg, #6B21A8 0%, #8A3FFC 100%)', name: '魔丸 直播中', avatar: 'https://via.placeholder.com/24' }
      ],
      // 乐器
      instrumentList: [
        { id: 1, bgColor: 'linear-gradient(135deg, #4ECDC4 0%, #7EDDD7 100%)', name: '兔小兔 直播中', avatar: 'https://via.placeholder.com/24' },
        { id: 2, bgColor: 'linear-gradient(135deg, #95E1D3 0%, #B8F0E6 100%)', name: '兔小兔 直播中', avatar: 'https://via.placeholder.com/24' },
        { id: 3, bgColor: 'linear-gradient(135deg, #A8D8EA 0%, #C5E7F5 100%)', name: '兔小兔 直播中', avatar: 'https://via.placeholder.com/24' },
        { id: 4, bgColor: 'linear-gradient(135deg, #FCBAD3 0%, #FDD4E5 100%)', name: '兔小兔 直播中', avatar: 'https://via.placeholder.com/24' },
        { id: 5, bgColor: 'linear-gradient(135deg, #F38181 0%, #F5A0A0 100%)', name: '魔丸 直播中', avatar: 'https://via.placeholder.com/24' }
      ]
    }
  },
   mounted() {
    // 页面加载获取初始2条数据
    // this.fetchInitialData()
    // 监听swiper滑动事件
    this.initSwiperEvent()
  },
  watch: {
    // 监听bannerList变化，确保swiper更新后再绑定事件
    bannerList: {
      handler() {
        this.$nextTick(() => {
          this.initSwiperEvent()
        })
      },
      deep: true
    }
  },
  methods: {
    goToLogin() {
      this.$router.push('/gr');
    },
    enterLiveRoom() {
      this.$router.push('/zb');
    },
    getSwiper() {
      return this.$refs.heroSwiper.$swiper
    },
    // 初始化swiper事件监听
    initSwiperEvent() {
      const swiper = this.getSwiper()
      if (swiper && !swiper._eventsBound) {
        swiper.on('slideChange', () => {
          this.onSlideChange()
        })
        swiper._eventsBound = true
      }
    },
    // 获取初始数据
    fetchInitialData() {
      // 使用axios请求接口 - 替换为真实接口地址
        axios.get('/api/banner/init').then(res => {
        this.bannerList = res.data.data
        this.nextData = res.data.nextData
      }).catch(err => {
        console.error('获取初始数据失败:', err)
      })
    },
    // 预加载下一条数据
    preloadNextData() {
      axios.get('/api/banner/next').then(res => {
        this.nextData = res.data.nextData
      }).catch(err => {
        console.error('预加载数据失败:', err)
      })
    },
    // 滑动到下一张
    onSlideChange() {
      const swiper = this.getSwiper()
      if (!swiper) return
      console.log(swiper.activeIndex)
      // 如果是滑向第二张（索引1），说明要显示第二条了
    //   if (swiper.activeIndex === 1 || (swiper.activeIndex === 0 && swiper.previousIndex === 1)) {
    //     // 把预加载的数据放到第一位
    //     this.$set(this.bannerList, 0, this.nextData)
    //     // 重新获取下一条数据
    //     this.preloadNextData()
    //   }
    },
    slidePrev() {
      const swiper = this.getSwiper()
      if (swiper) swiper.slidePrev()
    },
    slideNext() {
      const swiper = this.getSwiper()
      if (swiper) swiper.slideNext()
    }
  },
}
</script>

<style scoped lang="scss">
// 主容器
.home_page {
 padding: 0px 25px;
  background-color: #ffffff;
  min-height: 100vh;
}

// 顶部导航栏
.top_nav {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 0;
  margin-bottom: 8px;
  background-color: #fff;
}

// 导航左侧 - 分类链接（flex:1 占满剩余空间）
.nav_left {
  display: flex;
  align-items: center;
  justify-content: space-around;
  flex: 1;
  margin-right: 16px;
}

// 导航项
.nav_item {
  font-size: 14px;
  color: #666;
  text-decoration: none;
  position: relative;
  padding-bottom: 8px;
  transition: color 0.3s ease;
  white-space: nowrap;

  &:hover {
    color: #8B5CF6;
  }

  // 激活状态
  &.active {
    color: #8B5CF6;
    font-weight: 500;

    // 底部紫色下划线
    &::after {
      content: '';
      position: absolute;
      bottom: 0;
      left: 50%;
      transform: translateX(-50%);
      width: 20px;
      height: 3px;
      background: linear-gradient(135deg, #8B5CF6 0%, #A855F7 100%);
      border-radius: 2px;
    }
  }
}

// 导航右侧 - 按钮区域
.nav_right {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-shrink: 0;
}

// 开播按钮
.nav_btn_broadcast {
  width: 36px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #fff;
  border: 1px solid #E5E7EB;
  border-radius: 8px;
  color: #8B5CF6;
  font-size: 16px;
  cursor: pointer;
  transition: all 0.3s ease;

  &:hover {
    background: #F3F0FF;
    border-color: #8B5CF6;
  }
}

// 登陆按钮
.nav_btn_login {
  padding: 8px 20px;
  background: #fff;
  border: 1px solid #E5E7EB;
  border-radius: 8px;
  color: #666;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.3s ease;

  &:hover {
    background: #F3F0FF;
    border-color: #8B5CF6;
    color: #8B5CF6;
  }
}

// 轮播图区域
.hero_section {
  position: relative;
  margin-bottom: 32px;
  border-radius: 16px;
  overflow: hidden;
}

// 模糊背景层
.banner_bg_blur {
  position: absolute;
  top: -20px;
  left: -20px;
  right: -20px;
  bottom: -20px;
  background-size: cover;
  background-position: center;
  filter: blur(20px);
  z-index: 0;
}

.hero_swiper {
  height: 660px;
  border-radius: 16px;

  ::v-deep .swiper-container {
    height: 100%;
  }
}

.banner_item {
  position: relative;
  width: 100%;
  height: 100%;
}

.banner_img {
  position: relative;
  width: 100%;
  height: 100%;
  object-fit: contain;
  z-index: 3;
}

// 蒙层
.banner_overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(to right, rgba(0,0,0,0.6) 0%, rgba(0,0,0,0.2) 50%, transparent 100%);
  z-index: 3;
}

// 左侧信息
.banner_info {
  position: absolute;
  left: 32px;
  bottom: 32px;
  color: #fff;
  z-index: 3;
}

.live_tag {
  display: inline-block;
  padding: 4px 12px;
  background: linear-gradient(135deg, #FF6B6B 0%, #FF8E8E 100%);
  border-radius: 12px;
  font-size: 12px;
  margin-bottom: 12px;
}

.banner_title {
  font-size: 32px;
  font-weight: 600;
  margin-bottom: 8px;
  text-shadow: 0 2px 4px rgba(0,0,0,0.3);
}

.banner_subtitle {
  font-size: 24px;
  margin-bottom: 16px;
  text-shadow: 0 2px 4px rgba(0,0,0,0.3);
}

.anchor_info {
  display: flex;
  align-items: center;
  margin-bottom: 12px;
}

.anchor_avatar {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  margin-right: 8px;
  border: 2px solid #fff;
}

.anchor_name {
  font-size: 14px;
}

.stats {
  display: flex;
  gap: 16px;
}

.stat_item {
  font-size: 12px;
  opacity: 0.9;
}

// 进入按钮
.enter_btn {
  position: absolute;
  right: 46%;
  bottom: 32px;
  padding: 12px 32px;
  background: rgba(255,255,255,0.2);
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255,255,255,0.3);
  border-radius: 24px;
  color: #fff;
  font-size: 14px;
  cursor: pointer;
  z-index: 3;
  transition: all 0.3s ease;

  &:hover {
    background: rgba(255,255,255,0.3);
  }
}

// 轮播图导航按钮
.swiper_nav_btns {
  position: absolute;
  right: 24px;
  top: 50%;
  transform: translateY(-50%);
  display: flex;
  flex-direction: column;
  gap: 12px;
  z-index: 10;
}

.nav_btn {
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(255,255,255,0.2);
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255,255,255,0.3);
  border-radius: 50%;
  color: #fff;
  font-size: 16px;
  cursor: pointer;
  transition: all 0.3s ease;

  &:hover {
    background: rgba(255,255,255,0.4);
  }
}

// 区块通用样式
.section {
  margin-bottom: 32px;
}

.section_header {
  display: flex;
  align-items: baseline;
  gap: 12px;
  margin-bottom: 16px;
}

.section_title {
  font-size: 20px;
  font-weight: 600;
  color: #181426;
}

.section_subtitle {
  font-size: 12px;
  color: #9B8DC7;
}

// 甜筒精选
.featured_grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 16px;
}

.featured_card {
  cursor: pointer;
}

.card_image_wrap {
  position: relative;
  border-radius: 12px;
  overflow: hidden;
  margin-bottom: 12px;
}

.card_image {
  width: 100%;
  height: 180px;
  border-radius: 12px;
}

.card_overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(to top, rgba(0,0,0,0.4) 0%, transparent 50%);
}

.card_tag {
  position: absolute;
  top: 8px;
  left: 8px;
  padding: 2px 8px;
  border-radius: 4px;
  font-size: 12px;
  color: #fff;

  &.live {
    background: #FF6B6B;
  }

  &.replay {
    background: #9B8DC7;
  }
}

.viewer_count {
  position: absolute;
  top: 8px;
  right: 8px;
  display: flex;
  align-items: center;
  gap: 4px;
  font-size: 12px;
  color: #fff;
}

.card_info {
  display: flex;
  align-items: center;
  gap: 8px;
}

.card_avatar {
  width: 24px;
  height: 24px;
  border-radius: 50%;
}

.card_name {
  font-size: 14px;
  color: #4B3B73;
}

// 推荐类别
.category_grid {
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: 16px;
}

.category_card {
  position: relative;
  border-radius: 12px;
  overflow: hidden;
  cursor: pointer;
  height: 200px;
}

.category_image {
  width: 100%;
  height: 100%;
  border-radius: 12px;
}

.category_overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(to top, rgba(0,0,0,0.6) 0%, transparent 60%);
}

.category_tag {
  position: absolute;
  bottom: 40px;
  left: 12px;
  font-size: 16px;
  font-weight: 600;
  color: #fff;
}

.category_anchor {
  position: absolute;
  bottom: 12px;
  left: 12px;
  display: flex;
  align-items: center;
  gap: 6px;
}

.category_avatar {
  width: 20px;
  height: 20px;
  border-radius: 50%;
}

.category_name {
  font-size: 12px;
  color: #fff;
}

// 甜筒活动
.activity_grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 16px;
}

.activity_card {
  border-radius: 12px;
  overflow: hidden;
  cursor: pointer;
}

.activity_image {
  width: 100%;
  height: 120px;
  border-radius: 12px;
}

// 音乐和乐器
.live_grid {
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: 16px;
}

.live_card {
  cursor: pointer;
}

.live_image_wrap {
  position: relative;
  border-radius: 12px;
  overflow: hidden;
  margin-bottom: 8px;
}

.live_image {
  width: 100%;
  height: 200px;
  border-radius: 12px;
}

.live_status {
  position: absolute;
  top: 8px;
  left: 8px;
  padding: 2px 8px;
  background: #FF6B6B;
  border-radius: 4px;
  font-size: 12px;
  color: #fff;
}

.live_info {
  display: flex;
  align-items: center;
  gap: 6px;
}

.live_avatar {
  width: 20px;
  height: 20px;
  border-radius: 50%;
}

.live_name {
  font-size: 12px;
  color: #4B3B73;
}
</style>
